import {
    getBaseURL
} from '@/commons/utils';

/**
 * 定义非标准Token对象
 */
const tokenNames = {
    AKtoken: getBaseURL('punishment'),
    unitoken: getBaseURL('uni')
};

/**
 * 获取Token名称
 * @param {*} url
 */
export const getTokenName = (url) => {
    let tokenName;
    for (let tknKey in tokenNames) {
        if (url.indexOf(tokenNames[tknKey]) > -1) {
            tokenName = tknKey;
            break;
        }
    }
    return tokenName || 'token';
};

/**
 * 定义不做处理的接口地址集
 */
const FILTER_URLS = [
];

/**
 * 是否存在不做处理的接口集合中
 * @param {响应内容} response
 */
export const isPassUrls = (response) => {
    let url = new URL(response.request.responseURL).pathname;
    let code = response.data.code;
    if (code !== 500 && FILTER_URLS.includes(url)) {
        return true;
    }
    return false;
};
